"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductDetails = exports.useProductList = void 0;

var ProductDetails_1 = require("../../api/products/ProductDetails");

var ProductList_1 = require("../../api/products/ProductList");

var utils_1 = require("./utils");

exports.useProductList = utils_1.makeList(function (client) {
  return new ProductList_1.ProductList(client);
});
exports.useProductDetails = utils_1.makeDetails(function (client) {
  return new ProductDetails_1.ProductDetails(client);
});